<ion-header xmlns="http://www.w3.org/1999/html">
  <ion-toolbar style="--background: #00205B">
    <div class="ml-3.5 max-w-7xl px-2 sm:px-6 lg:px-8">
      <div class="relative flex h-16 items-center justify-between">
        <div class="flex flex-1 items-left justify-left sm:items-stretch sm:justify-start">
          <div class="flex flex-shrink-0 items-start">
            <a href="#">
              <img class=" h-auto w-[50%] lg:block" src="/assets/trademark/teleflex.png" alt="Teleflex"/>
              <h1 style="color:white" class="pt-1 font-bold">Product Performance Evaluation</h1>
            </a>
          </div>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
